import React from 'react';
import { Smartphone, X } from 'lucide-react';
import { pinShortcut } from '../hooks/useHomeShortcut';

/** Small popover shown after a long-press / right-click on a Social tab or button. */
export const HomeShortcutMenu = ({ target, onClose }) => {
  if (!target) return null;
  const left = Math.min(Math.max(8, target.x - 20), (window.innerWidth || 400) - 260);
  const top = Math.min(Math.max(8, target.y - 10), (window.innerHeight || 700) - 110);
  return (
    <div className="fixed inset-0 z-[90]" onClick={onClose} data-testid="home-shortcut-backdrop">
      <div
        className="absolute w-[250px] rounded-xl border bg-white shadow-2xl p-3 space-y-2"
        style={{ left, top }}
        onClick={(e) => e.stopPropagation()}
        data-testid="home-shortcut-menu"
      >
        <div className="flex items-start justify-between gap-2">
          <p className="text-xs text-muted-foreground leading-snug">Quick access to <span className="font-semibold text-foreground">{target.label}</span></p>
          <button type="button" onClick={onClose} className="text-muted-foreground" data-testid="home-shortcut-close"><X className="w-3.5 h-3.5" /></button>
        </div>
        <button
          type="button"
          onClick={() => { pinShortcut(target.label, target.path); onClose(); }}
          className="w-full flex items-center gap-2 rounded-lg bg-forest-700 hover:bg-forest-800 text-white text-sm px-3 py-2"
          data-testid="home-shortcut-add"
        >
          <Smartphone className="w-4 h-4" /> Add to phone home screen
        </button>
      </div>
    </div>
  );
};
